import { Select } from 'antd';
import React from 'react';

import { t } from '@System/i18n';

import { ORDER_STATUS } from '../services/constants';

const { Option } = Select;

export default function SelectStatuses(props) {
    return (
        <Select
            {...props}
            value={props.value || undefined}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {Object.keys(ORDER_STATUS).map(opt => {
                return (
                    <Option key={ORDER_STATUS[opt]} value={ORDER_STATUS[opt]}>
                        {t(`order:status.${ORDER_STATUS[opt]}`)}
                    </Option>
                );
            })}
        </Select>
    );
}
